import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";
import { BaseService } from "./BaseService";

export class BenchmarkRankUnivService extends BaseService {
  burgissCalcPooledRankingIRRByWeight(
    universe: any,
    weight: any[][],
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      weight,
      null,
      startDate,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.IRR,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingIRRByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingTWRRByWeight(
    universe: any,
    weight: any[][],
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string,

    dynamicParameter?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      weight,
      null,
      startDate,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.TWRR,
      dynamicParameter
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingTWRRByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingDPIByWeight(
    universe: any,
    weight: any[][],
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      weight,
      null,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.DPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingDPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingRVPIByWeight(
    universe: any,
    weight: any[][],
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      weight,
      null,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.RVPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingRVPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingTVPIByWeight(
    universe: any,
    weight: any[][],
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      weight,
      null,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.TVPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingTVPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingIRRByCommitment(
    universe: any,
    commitment?: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      null,
      commitment,
      startDate,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.IRR,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingIRRByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingTWRRByCommitment(
    universe: any,
    commitment?: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string,
    dynamicParameter?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      null,
      commitment,
      startDate,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.TWRR,
      dynamicParameter
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingTWRRByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingDPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      null,
      commitment,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.DPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingDPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingRVPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      null,
      commitment,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.RVPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingRVPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }
  burgissCalcPooledRankingTVPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      universe,
      null,
      commitment,
      null,
      endDate,
      currency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      MeasuresType.TVPI,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledRankingTVPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIORANKINGUNIV,
      FunctionGroup.BenchmarkRankUniverse
    );
  }

  createPayload(
    alias: string = null,
    universe: any = null,
    weight: any[][] = null,
    commitment: any = null,
    startDate: any = null,
    endDate: any = null,
    currency: string = null,
    sampleStatistic: any = null,
    rankValue: any = null,
    numSimulations: any = null,
    desiredSampleSize: any = null,
    requireReportedValuation: any = null,
    stopOn: any = null,
    alternateCurrrency: string = null,
    measure: string = null,

    dynamicParameter: any = null
  ) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: null,
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternateCurrrency,
      attributeName: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: startDate,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: "i",
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: null,
      rankValue: rankValue,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: numSimulations,
      desiredSampleSize: desiredSampleSize,
      minSampleSize: null,
      sampleStatistic: sampleStatistic,
      stopOn: stopOn,
      requireReportedValuation: requireReportedValuation,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: dynamicParameter,
      universe: universe,
      weight: weight,
      commitment: commitment,
    };
    return measuresObject;
  }
}
